import styles from "./chat-message.module.scss";
import cn from "classnames";
import { ImessageObject } from "@api/types/chat";
import { ReactComponent as Heart } from "@assets/svg/heart.svg";
import { ReactComponent as Arrow } from "@assets/svg/reply-arrow.svg";
import { animated, useTransition } from "react-spring";
import { useState, useContext, useCallback } from "react";
import { replyContext } from "@components/chat";
import { useMutation } from "@apollo/client";
import { LIKE_MESSAGE, UNLIKE_MESSAGE } from "@graphql/Mutations";
import useReduxState from "@hooks/useReduxState";
import { SocketContext } from "@context/socket";
import { toastErrorMessage } from "@utils/utils";

export default function ChatMessage({
  message,
}: {
  message: ImessageObject;
}): JSX.Element {
  const [isHover, setIsHover] = useState(false);
  const arrowTransition = useTransition(isHover, {
    from: {
      opacity: 0,
      y: 15,
    },
    enter: {
      opacity: 1,
      y: 0,
    },
    leave: {
      opacity: 0,
      y: 15,
    },
  });
  const [user] = useReduxState((state) => state.userData);
  const { setReply } = useContext(replyContext);
  const socket = useContext(SocketContext);
  const [likeMessage] = useMutation(LIKE_MESSAGE, {
    onCompleted: () => {
      socket.emit("New-Like", {
        userId: user.id,
        messageId: message.id,
      });
    },
    onError: (error) => {
      toastErrorMessage(error.message);
    },
  });
  const [unlikeMessage] = useMutation(UNLIKE_MESSAGE, {
    onCompleted: () => {
      socket.emit("Unlike", {
        userId: user.id,
        messageId: message.id,
      });
    },
    onError: (error) => {
      toastErrorMessage(error.message);
    },
  });
  const userHasLiked = message.likes.includes(user.id);
  const handleLike = useCallback(async () => {
    console.log(message);
    await likeMessage({
      variables: {
        userId: user.id,
        mId: message.id,
      },
    });
  }, [message]);
  const handleUnlike = useCallback(async () => {
    await unlikeMessage({
      variables: {
        userId: user.id,
        mId: message.id,
      },
    });
  }, [message]);

  return (
    <div
      className={styles.message}
      onMouseEnter={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        setIsHover(false);
      }}
    >
      {message.reply && (
        <div className={styles.reply}>
          <Arrow />
          <img src={message.reply.user.avatar_url} />
          <span>
            <b>@{message.reply.user.username}: </b>
            {message.reply.message}
          </span>
        </div>
      )}
      <div className={styles.message_content}>
        {arrowTransition(
          (style, item) =>
            item && (
              <animated.div style={style} className={styles.message_actions}>
                <button
                  className={styles.action_btn}
                  onClick={() => setReply(message)}
                >
                  <Arrow />
                </button>
                <button
                  className={cn(styles.action_btn, {
                    [styles.liked]: userHasLiked,
                  })}
                  onClick={() => (userHasLiked ? handleUnlike() : handleLike())}
                >
                  <Heart />
                </button>
              </animated.div>
            )
        )}
        <img src={message.user.avatar_url} alt="pp" />
        <div className={styles.message_section}>
          <h4>{message.user.username}</h4>
          <p>{message.message}</p>
        </div>

        <div className={styles.likes}>
          {message.likes.length}
          <Heart />
        </div>
      </div>
    </div>
  );
}
